import Journeys from "utils/Journeys"
import Interests from "utils/Interests"
import L10n from "../lib/carrot-l10n"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const JourneySummaryKeys = {
  [Journeys.LEARN_MORE]: {
    [Interests.UNDERSTAND_MY_FERTILITY]: "journeySummary.learnMore.understand",
    [Interests.PREGNANCY]: "journeySummary.learnMore.pregnancy",
    [Interests.EGG_FREEZING]: "journeySummary.learnMore.eggFreezing",
    [Interests.EMBRYO_FREEZING]: "journeySummary.learnMore.embryoFreezing",
    [Interests.SPERM_FREEZING]: "journeySummary.learnMore.spermFreezing",
    [Interests.IVF]: "journeySummary.learnMore.IVF",
    [Interests.IUI]: "journeySummary.learnMore.IUI",
    [Interests.ADOPTING]: "journeySummary.learnMore.adopting",
    [Interests.GESTATIONAL_CARRIER]: "journeySummary.learnMore.gestationalCarrier",
    [Interests.SOMETHING_ELSE]: "journeySummary.learnMore.somethingElse"
  },
  [Journeys.READY_FOR_NEXT_STEP]: {
    [Interests.UNDERSTAND_MY_FERTILITY]: "journeySummary.nextStep.understand",
    [Interests.EGG_FREEZING]: "journeySummary.nextStep.eggFreezing",
    [Interests.EMBRYO_FREEZING]: "journeySummary.nextStep.embryoFreezing",
    [Interests.SPERM_FREEZING]: "journeySummary.nextStep.spermFreezing",
    [Interests.IVF]: "journeySummary.nextStep.IVF",
    [Interests.IUI]: "journeySummary.nextStep.IUI",
    [Interests.ADOPTING]: "journeySummary.nextStep.adopting",
    [Interests.GESTATIONAL_CARRIER]: "journeySummary.nextStep.gestationalCarrier",
    [Interests.SOMETHING_ELSE]: "journeySummary.nextStep.somethingElse"
  },
  [Journeys.TAKING_ACTION]: {
    [Interests.UNDERSTAND_MY_FERTILITY]: "journeySummary.receivingCare.understand",
    [Interests.EGG_FREEZING]: "journeySummary.receivingCare.eggFreezing",
    [Interests.EMBRYO_FREEZING]: "journeySummary.receivingCare.embryoFreezing",
    [Interests.SPERM_FREEZING]: "journeySummary.receivingCare.spermFreezing",
    [Interests.IVF]: "journeySummary.receivingCare.IVF",
    [Interests.IUI]: "journeySummary.receivingCare.IUI",
    [Interests.ADOPTING]: "journeySummary.receivingCare.adopting",
    [Interests.GESTATIONAL_CARRIER]: "journeySummary.receivingCare.gestationalCarrier",
    [Interests.SOMETHING_ELSE]: "journeySummary.receivingCare.somethingElse",
    [Interests.INITIAL_FERTILITY_TESTING]: "journeySummary.receivingCare.initialFertilityTesting",
    [Interests.TRYING_TO_GET_PREGNANT]: "journeySummary.receivingCare.tryingToGetPregnant"
  },
  [Journeys.PREGNANCY]: {
    [Interests.PREGNANT]: "journeySummary.receivingCare.pregnant"
  }
}

const JourneySummaryPronouns = {
  [Journeys.LEARN_MORE]: {
    first: {
      singular: l`pronouns.I`,
      plural: l`pronouns.We`
    },
    second: {
      singular: l`pronouns.my`,
      plural: l`pronouns.our`
    }
  },

  [Journeys.READY_FOR_NEXT_STEP]: {
    first: {
      singular: l`pronouns.I'm`,
      plural: l`pronouns.We're`
    },
    second: {
      singular: l`pronouns.my`,
      plural: l`pronouns.our`
    }
  },
  [Journeys.TAKING_ACTION]: {
    first: {
      singular: l`pronouns.I'm`,
      plural: l`pronouns.We're`
    }
  },
  [Journeys.PREGNANCY]: {
    first: {
      singular: l`pronouns.I'm`,
      plural: l`pronouns.We're`
    }
  }
}

export { JourneySummaryKeys, JourneySummaryPronouns }
